import { themeDefault } from './theme.default';

export const themes = { themeDefault };
